import { Select, Spin } from "antd";
import { useDynamicSelectOptions } from "./infiniteSelect.services";
import { useTranslation } from "react-i18next";

type Props = {
  onChange?: (value: string) => void;
  url: string;
  optionsKeys: {
    label: string;
    value: string;
  };
  params?: Record<string, any>;
  placeholder?: string;
  queryKey?: string[];
  disabled?: boolean;
  shouldFetch?: boolean;
  value?: string | number;
};

export const InfiniteSelect = ({
  onChange,
  url,
  optionsKeys,
  placeholder,
  params,
  queryKey,
  disabled,
  shouldFetch,
  value,
}: Props) => {
  const { i18n } = useTranslation();

  const queryKeys = queryKey ? [`${url}-key`, ...queryKey] : [`${url}-key`];
  const { options, isLoading, fetchNextPage } = useDynamicSelectOptions({
    url,
    queryKey: queryKeys,
    params,
    shouldFetch,
  });

  const handlePopupScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } =
      e.target as HTMLDivElement;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      fetchNextPage();
    }
  };

  return (
    <Select
      showSearch
      placeholder={placeholder}
      onChange={onChange}
      onPopupScroll={handlePopupScroll}
      options={
        !disabled
          ? options.map((item) => ({
              label:
                item[optionsKeys?.label][i18n.language || "en"] ||
                item[optionsKeys?.label],
              value: item[optionsKeys?.value]?.en || item[optionsKeys?.value],
            }))
          : []
      }
      notFoundContent={
        isLoading && !disabled ? <Spin size="small" /> : "No Items Found"
      }
      value={value}
      style={{ width: "100%" }}
      disabled={disabled}
    />
  );
};
